define('fukit/behavior/bind.and.format.option.values.behavior',['require','exports','module','underscore','marionette'],function(require, exports, module) {
  //prettier-ignore
  var _  = require('underscore'),
      Mn = require('marionette');

  var BindAndFormatOptionValuesBehavior = Mn.Behavior.extend({
    defaults: {
      // Sets a listener on an event (EventName) and will set the current view's option value to (if used) whatever is specified in
      // the formatter. Check the formatAndSetOptionFromModelAttribute function for more detail.
      //
      // You can also use model, and collection. If none is specified then you can use a formatWithoutResource function [I believe that this might set the
      // model to null since it passes this.formatAndSetOptionFromModelAttribute(option, null, null, formatter) with null values, but this has not been
      // confirmed].
      //
      //
      // Note: You do not need to have set an attribute since it never checks for one.
      //
      // Examples:
      // {
      //  disabled: {
      //      resource: '@state'
      //      attribute: 'previousVersionId'
      //      eventName: 'change' // default
      //   }
      // }
      //          -or-
      // {
      //  visible: {
      //     model: '@resources.workflowTaskModel',
      //     eventName: 'change:taskDefinitionKey',
      //   }
      // }
      optionValues: null,
      formatWithoutModel: false,
    },

    initialize: function() {
      this.optionValues = this.getOption('optionValues');

      this.listenToOnce(this.view, 'before:render', this.initializeBindings);
    },

    getResource: function() {
      return this.getOption('resource') || this.getOption('model') || this.view.model;
    },

    initializeBindings: function() {
      this._resource = this.getResource();
      var initialViewModel = this.view.model;

      _.each(
        this.optionValues,
        function(optionValue, option) {
          optionValue || (optionValue = {});
          //prettier-ignore
          var attribute = optionValue.attribute || optionValue.modelAttribute,
            formatter = optionValue.formatter,
            resource = optionValue.resource || optionValue.model || this._resource,
            formatWithoutResource = optionValue.formatWithoutResource,
            eventName;

          if (resource instanceof Backbone.Model) {
            eventName = optionValue.eventName || (attribute ? 'change:' + attribute : 'change');
          } else if (resource instanceof Backbone.Collection) {
            eventName = optionValue.eventName || 'change update reset';
          }

          // if resource is a view model, account for model change
          if (resource == initialViewModel) {
            this.listenTo(this.view, 'change:model', function(view, newModel, oldModel, options) {
              if (oldModel) {
                this.stopListening(oldModel, eventName);
              }
              this.setResourceOptionBindings(
                this.view.model,
                option,
                eventName,
                attribute,
                formatter,
                formatWithoutResource
              );
            });
          }

          this.setupResourceBindings(resource, option, eventName, attribute, formatter, formatWithoutResource);
        },
        this
      );

      this.executeBindings();
    },

    setupResourceBindings: function(resource, option, eventName, attribute, formatter, formatWithoutResource) {
      if (!this._resourceBindingQueue) {
        this._resourceBindingQueue = [];
      }

      var self = this;

      this._resourceBindingQueue.push({
        optionName: option,
        callback: function() {
          self.setResourceOptionBindings(resource, option, eventName, attribute, formatter, formatWithoutResource);
        },
      });
    },

    executeBindings: function() {
      while (this._resourceBindingQueue.length > 0) {
        this._resourceBindingQueue.shift().callback();
      }
    },

    setResourceOptionBindings: function(resource, option, eventName, attribute, formatter, formatWithoutResource) {
      var result = _.findWhere(this._resourceBindingQueue, { optionName: option });
      this._resourceBindingQueue = _.without(this._resourceBindingQueue, result);

      if (resource instanceof Backbone.Model) {
        this.formatAndSetOptionFromModelAttribute(option, resource, attribute, formatter);
        this.listenTo(resource, eventName, function() {
          this.formatAndSetOptionFromModelAttribute(option, resource, attribute, formatter);
        });
      } else if (resource instanceof Backbone.Collection) {
        this.formatAndSetOptionFromModelAttribute(option, resource, null, formatter);
        this.listenTo(resource, eventName, function() {
          this.formatAndSetOptionFromModelAttribute(option, resource, null, formatter);
        });
      } else if (formatWithoutResource || this.getOption('formatWithoutModel')) {
        this.formatAndSetOptionFromModelAttribute(option, null, null, formatter);
      }
    },

    formatAndSetOptionFromModelAttribute: function(option, resource, attribute, formatter) {
      var value = attribute ? (resource ? resource.get(attribute) : null) : resource;
      if (_.isFunction(formatter)) {
        this.view[option] = formatter.call(this, value);
      } else {
        this.view[option] = value;
      }
    },
  });

  module.exports = BindAndFormatOptionValuesBehavior;
});

